function format(text = "", data = {}) {
  if (text.length <= 0 || Object.keys(data).length <= 0) {
    return text;
  }

  let keys = Object.keys(data);
  let finalResult = text;

  keys.map(key => {
    finalResult = finalResult.replace(`{${key}}`, data[key]);
  });
  
  return finalResult;
}

export {format};
